import React, { useEffect, useState, createContext } from 'react';
import Profile from './components/profile';
import EditProfile from './components/edit-profile';
import NewChild from './components/new-child';
import ChildrenAccounts from './components/children-accounts';
import ProfileDetail from './components/profile-detail';
import Login from './components/login';
import Invite from './components/invitation';
import { Router, globalHistory } from '@reach/router';
import { ThemeModeProvider } from './lib/hooks/use-theme-mode';
import { Provider } from 'mobx-react';
import authStore from './lib/stores/auth.store';
import gymStore from './lib/stores/gym.store';
import GymAdmin from './components/admin/gym-admin';
import GymUsers from './components/admin/pages/gym-users';
import GymDashBoard from './components/admin/pages/gym-dashboard';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import Cookies from 'js-cookie';
import get from 'lodash.get';
import Help from './components/help';
import KioskCheckin from './components/admin/pages/kiosk-checkin';
import Privacy from './components/privacy';
import ReactGA from 'react-ga4';
import DisabledUsers from './components/admin/pages/disabled-users';
import Promotions from './components/admin/pages/promotions';
import NewPromotion from './components/admin/pages/new-promotion';
import EditPromotion from './components/admin/pages/edit-promotion';
import FeedbackQueue from './components/admin/pages/feedback-queue';
import UserPermissions from './components/admin/pages/user-permissions';
import NewsFeed from './components/news-feed';
import PrivateLessons from './components/private-lessons';
import PrivateLessonSchedule from './components/admin/pages/private-lesson-schedule';
import MemberExplorer from './components/admin/pages/member-explorer';

export const AppContext = createContext();
ReactGA.initialize('G-8V8789W135');
const AppProvider = ({ value, children }) => {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

const App = () => {
  const [loggedInUserId, setLoggedInUserId] = useState(null);

  const fetchAuthToken = async () => {
    firebase.auth().onAuthStateChanged(async (authInfo) => {
      if (authInfo && authInfo.uid) {
        setLoggedInUserId(authInfo.uid);
        const idTokenObject = await authInfo.getIdTokenResult(true);
        const idTokenResult = get(idTokenObject, 'token', '');
        Cookies.set('authToken', idTokenResult);
        return idTokenResult;
      }
    });
  };

  useEffect(() => {
    fetchAuthToken();
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('ready');
    }
  }, []);

  useEffect(() => {
    return globalHistory.listen(({ location }) => {
      ReactGA.send({
        hitType: 'pageview',
        page: `${location.pathname} ${location.search}`,
      });
    });
  }, []);

  return (
    <Provider userStore={authStore} gymStore={gymStore}>
      <AppProvider value={{ loggedInUserId }}>
        <ThemeModeProvider>
          <Router>
              <Profile path="/profile">
                <ProfileDetail path=":userId" />
                <ProfileDetail path=":userId/:child" />
                <EditProfile path=":userId/edit" />
                <EditProfile path=":userId/edit/:signup" />
                <NewChild path=":userId/children/:child" />
                <ChildrenAccounts path=":userId/children" />
              </Profile>
              <Help path="/help" />
              <Login path="/" />
              <Login path="/login/:gymId" />
              <Login path="/login" />
              <Invite path="/invite" />
              <NewsFeed path="/news-feed" />
              <PrivateLessons path="/private-lessons" />
              <Privacy path="/privacy" />
              <GymAdmin path="/admin">
                <GymDashBoard path="dashboard/:gymUid" />
                <GymUsers path="gyms/:gymUid/users" />
                <MemberExplorer path="gyms/:gymUid/member-explorer" />
                <DisabledUsers path="gyms/:gymUid/disabled-users" />
                <KioskCheckin path="gyms/:gymUid/kiosk" />
                <FeedbackQueue path="gyms/:gymUid/feedback-queue" />
                <UserPermissions path="gyms/:gymUid/user-permissions" />
                <PrivateLessonSchedule path="gyms/:gymUid/private-lessons" />
                <Promotions path="gyms/:gymUid/promotions" />
                <NewPromotion path="gyms/:gymUid/promotions/new" />
                <EditPromotion path="gyms/:gymUid/promotions/edit/:promoId" />
              </GymAdmin>
              <Help path="/remove-account" />
          </Router>
        </ThemeModeProvider>
      </AppProvider>
    </Provider>
  );
};

export default App;
